import React from "react";
import { Modal } from "@mrwa/rime-replacement/esriControls/general/Dialog";
import {
  ApplicationMessage,
  messageState,
} from "@mrwa/rime-replacement/esriControls/general/ApplicationMessage";
import { getFileName } from "../data/fileType";

export default class VideoToGpsMatchDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = { selections: [] };

    this.handleSelect = this.handleSelect.bind(this);
    this.handleAccept = this.handleAccept.bind(this);
    this.handleMappings = this.handleMappings.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps === this.props) return;

    this.handleMappings();
  }

  handleMappings() {
    const videosArray = Array.from(
      (this.props.videoFiles ?? []).map((item) => getFileName(item))
    );
    const gpsArray = Array.from(
      (this.props.gpsFiles ?? []).map((item) => getFileName(item))
    );
    const videoNames = videosArray.map((video) =>
      video.slice(0, video.lastIndexOf("."))
    );
    const gpsNames = gpsArray.map((gps) => gps.slice(0, gps.lastIndexOf(".")));

    const selections = videoNames
      .map((videoName, i) => {
        const gpsIndex = gpsNames.indexOf(videoName);
        if (gpsIndex >= 0)
          return { video: videosArray[i], gps: gpsArray[gpsIndex] };
        return null;
      })
      .filter((x) => x);
    this.setState({ selections });
  }

  handleAccept() {
    //ensure selected data files are unique
    const selectionsSet = new Set(
      this.state.selections.map((item) => item.gps)
    );
    const hasDuplicates = selectionsSet.size !== this.state.selections.length;

    //ensure items have been selceted for each video
    const hasDefaultSelected = this.state.selections.find(
      (item) => item.gps === ""
    );

    if (
      hasDefaultSelected ||
      this.state.selections.length !== this.props.videoFiles.length
    ) {
      messageState.message = ApplicationMessage.Error(
        "All videos must have a GPS metadata file selection"
      );
      return;
    }
    if (hasDuplicates) {
      messageState.message = ApplicationMessage.Info(
        "All videos must have a unique GPS metadata file selected"
      );
      return;
    }

    this.props.onAccept(this.state.selections);
  }

  handleSelect(e) {
    const foundIndex = this.state.selections.findIndex(
      (item) => item.video === e.target.name
    );
    if (foundIndex >= 0) {
      const previousState = [...this.state.selections];
      previousState[foundIndex].gps = e.target.value;
      this.setState({
        selections: previousState,
      });
    } else {
      this.setState({
        selections: [
          ...this.state.selections,
          { video: e.target.name, gps: e.target.value },
        ],
      });
    }
  }

  gpsToVideoMatch(videoName) {
    const selection =
      this.state.selections &&
      this.state.selections.find(({ video }) => video === videoName);
    return selection ? selection.gps : "";
  }

  render() {
    const footerContents = (
      <>
        <button type="button" onClick={this.handleAccept}>
          Confirm
        </button>
        <button type="button" className="light" onClick={this.props.onReject}>
          Cancel
        </button>
      </>
    );
    const modalProps = {
      show: !this.props.showVideoToGpsMatchDialog,
      onReject: this.props.onReject,
      title: "Match Files",
      footerContents,
    };

    return (
      !this.props.hidden && (
        <Modal {...modalProps}>
          <div>
            {this.props.videoFiles && this.props.gpsFiles
              ? this.props.videoFiles.map((video, i) => (
                  <div key={i} className="formInput">
                    <label>{getFileName(video)}</label>
                    <select
                      name={getFileName(video)}
                      onChange={this.handleSelect}
                      value={this.gpsToVideoMatch(getFileName(video))}
                    >
                      <option value="">Select GPS metadata file</option>
                      {this.props.gpsFiles.map((gps, i) => (
                        <option key={i} value={getFileName(gps)}>
                          {getFileName(gps)}
                        </option>
                      ))}
                    </select>
                  </div>
                ))
              : null}
          </div>
        </Modal>
      )
    );
  }
}
